export const getStatusName = (assignment) => assignment ? assignment.confirmationStatusName
    .replace(' ', '')
    .toLowerCase() : '';